// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"282e6be3","453":"bdfc3c16","455":"919f9463","487":"a36c27d3","931":"7d0f4bc0","977":"80a48344"}[chunkId] + ".chunk.js";
};